import { Component, OnInit, OnDestroy, EventEmitter, Output, Input } from '@angular/core';
import { PedidoModel } from './../../../../models/pedido.model'
import { UsersService } from '../../../../models/usuarios.service'
import { QueryFn, AngularFirestore } from 'angularfire2/firestore';
import { DataModel } from '../../../../models/data.model';

@Component({
  selector: 'app-pedidos-novos',
  templateUrl: './pedidos-novos.component.html',
  styleUrls: ['./pedidos-novos.component.scss']
})
export class PedidosNovosComponent implements OnInit, OnDestroy {

  pedidosNovos: any[] = [];
  private pedidoModel: PedidoModel;
  carregando: boolean = true
  canModify = false;
  @Output() closeEvent: EventEmitter<boolean> = new EventEmitter<boolean>()
  @Output() filaVaziaEvent: EventEmitter<boolean> = new EventEmitter<boolean>()
  private _pesquisaValue: string = ''

  @Input()
  get pesquisaValue(): string {
    return this._pesquisaValue
  }
  set pesquisaValue(value: string) {
    this._pesquisaValue = value.trim().toLowerCase()
  }

  compararPesquisaNomeCliente(pedido: any): boolean {
    if (!(pedido.itens && (pedido.itens.length > 0)))
      return false
    if (this.pesquisaValue.length <= 2)
      return false
    let nome = pedido.itens[0].entrega.nome || pedido.itens[0].cliente.nome
    nome = nome.toLowerCase().trim()
    let result: boolean = ((nome == this.pesquisaValue) || (nome.includes(this.pesquisaValue)))
    return result
  }
  dbConn: AngularFirestore;
  constructor (
    private usersService: UsersService,

  ) {
    this.dbConn = usersService.usuarioClass.dbConn;
    this.pedidoModel = new PedidoModel(usersService.usuarioClass.dbConn, this.usersService)
    let where: QueryFn =
      (elem) => {
        this.canModify = false;
        if (this.usersService.isAdmin) {
          return elem.where('estado', '==', 0)
        } else {
          this.canModify = this.usersService.isFornecedor || this.usersService.isGestor;
          return elem.where('fornecedor', '==', this.usersService.fornecedor)
            .where('estado', '==', 0)
        }
      }
    this.pedidoModel.pedidoClass.snapshot(where, (data) => {
      this.carregando = false
      if (data && (data.length > 0)) {
        this.separarPorPedido(data)
        this.filaVaziaEvent.emit(false)
      }
      else if (data && (data.length == 0)) {
        this.separarPorPedido(data)
        this.filaVaziaEvent.emit(true)
      }
      console.log(this.pedidosNovos);
      console.log('sino');
      this.removerSino()

    }, true)
  }

  ngOnInit() {


  }

  private async alterarEstadoPedido(pedidoIndex: number, estado) {
    let pedido = []
    for (let elem of this.pedidosNovos[pedidoIndex].itens) { pedido.push(Object.assign({}, elem)) }

    this.pedidosNovos.splice(pedidoIndex)
    this.closeEvent.emit(true)

    setTimeout(async () => {
      for (let elem of pedido) {
        console.log(elem);
        try {
          await this.pedidoModel.alterarEstado(pedido, elem, estado)
          this.pedidoModel.enviarMensagemMovimentacaoEstado(elem.cliente.email, pedido, elem, this.pedidoModel.localizaEstado(estado))
        }
        catch (Err) {
          console.log(Err.message || JSON.stringify(Err))

        }

      }
    }, 500)
  }
  private separarPorPedido(pedidos: any[]) {
    let pedidosNovos = []
    for (let item of pedidos) {
      if (pedidosNovos.indexOf(item.pedido) === -1) {
        pedidosNovos.push(item.pedido)
      }
    }
    pedidosNovos.sort()
    for (let i = 0; i < pedidosNovos.length; i++) {
      const dcto = pedidosNovos[i]
      pedidosNovos[i] =
        {
          dcto,
          itens: pedidos.filter(function (elem) { return (elem.pedido == dcto) })
        }
    }
    this.pedidosNovos = pedidosNovos
  }
  public fmtQtde(qtde: number): string {
    return PedidoModel.formatQtde(qtde)
  }

  ngOnDestroy() {
    if (this.pedidosNovos.length == 0)
      this.removerSino()
  }

  removerSino() {
    const img = document.getElementById('img-sino')
    if (img)
      document.getElementsByTagName('body')[0].removeChild(img)
  }

  getDadosLoja(codLoja: number) {
    //let dm = new DataModel(this.dbConn, 'fornecedores');
    //return dm.snapshot(w => w.where('codigo', '==', codLoja), rsp => {
    //  console.log(rsp, rsp.data());
    //  return rsp.data();
    //})
    return this.dbConn.collection('nc-fornecedores', w => w.where('codigo', '==', codLoja))
      .ref
      .get().then(rsp => {
        console.log(rsp.docs);
        return rsp.docs;
      });


  }

}
